import { useEffect, useState } from 'react';
import { ACSApi, ToastStateHandler } from '../../../api';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';
import { ProjectWithAssigneesDto } from '../../../commonTypes/acs';

const useHttpGetProjectWithClientUserBranch = (id: string) => {
    const acsApi: ACSApi = useContainer(ACSApi);
    const toastHandler = useContainer(ToastStateHandler);
    const [isReady, setIsReady] = useState(false);
    const [project, setProject] = useState<ProjectWithAssigneesDto>();
    const { t } = useTranslation('newNotifications');

    const getProjects = (assigneeStatus?: string) => {
        if (!id) {
            setIsReady(true);
            return;
        }

        const { exec, abort } = acsApi.getProjectWithClientUserBranch({
            params: { id },
            query: { assigneeStatus },
            onSuccess: res => {
                setProject(res.body);
            },
            onError: _ => toastHandler.push('error', t('common.error'), t('common.somethingWentWrong')),
            onFinally: () => setIsReady(true),
        });

        exec();
        return abort;
    };

    useEffect(() => {
        if (!id) {
            setIsReady(true);
            return;
        }
        getProjects();
    }, [id]);

    return { isReady, project, setProject, getProjects };
};

export default useHttpGetProjectWithClientUserBranch;
